module.exports = __webpack_public_path__ + "media/images/childcare/cover-desktop@2x-42f6a58aaf9290cd7d31992dcc663e7e.jpg";